<template>
  <div class="container_box">
    <!--头部筛选区域-->
    <div class="filter_box">
      <Form ref="pageParams" :model="pageParams" :label-width="labelWidth" @submit.native.prevent>
        <Row type="flex" :gutter="gutterItem">
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <dropDownFilter
              :transfer="false"
              ref="dropDownTextareaFilter"
              inputType="textarea"
              :selectStyle="{width: '110px'}"
              :dropDownInputList="dropDownTextareaList"
              :defaultSelectValue="defaultTextareaValue"
              @changeInput="changeTextareaInput"
              @updateInputValue="updateTextareaValue">
            </dropDownFilter>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="`${configCharacters(false)}` + 'SKU：'" prop="ymsSkus">
              <Input :placeholder="$t('key1000324')+`${configCharacters(false)}`+$t('key1005014')" v-model.trim="pageParams.ymsSkus" type="textarea"></Input>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <dropDownFilter
              :transfer="false"
              ref="dropDownFilter"
              :selectStyle="{width: '110px'}"
              optionType="select"
              :dropDownInputList="dropDownInputList"
              :dropDownList="dropDownList"
              :defaultSelectValue="defaultSelectValue"
              @changeInput="changeInput"
              @updateInputValue="updateInputValue">
            </dropDownFilter>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1004132')">
              <Date-picker
                type="datetimerange"
                class="wid100P"
                @on-clear="resetDate"
                @on-change="getDateValue"
                :clearable="true"
                :options="dateOptions"
                format="yyyy-MM-dd HH:mm:ss"
                placement="bottom-end"
                :placeholder="$t('key1000360')"
                :value="deliveryTime">
              </Date-picker>
            </Form-item>
          </Col>
          <Col style="min-width: 200px;" push="1">
            <Button @click="reset" icon="md-refresh" class="mr10">{{ $t('key1000109') }}</Button>
            <Button type="primary" @click="search" icon="md-search">{{ $t('key1000361') }}</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <!--功能按钮操作区域-->
    <div class="operation_box">
      <Dropdown transfer @on-click="changeExportBtn" v-if="getPermission('ymsPackageInfoDataCenter_export')">
        <Button type="primary">
          <span>{{ $t('key1003082') }}</span>
          <Icon type="ios-arrow-down"></Icon>
        </Button>
        <DropdownMenu slot="list">
          <DropdownItem name="1">{{ $t('key1003083') }}</DropdownItem>
          <DropdownItem name="2">{{ $t('key1003084') }}</DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </div>
    <!--列表区域-->
    <div class="table_box">
      <Table
        ref="selection"
        highlight-row
        border
        max-height="500"
        :loading="tableLoading"
        :columns="tableColumns"
        @on-selection-change="tableChange"
        :data="tableData">
      </Table>
      <Page
        :transfer="true"
        v-if="!tableLoading"
        :total="total"
        @on-change="changePage"
        show-total
        :page-size="pageParams.pageSize"
        show-elevator
        :current="pageParams.pageNum"
        show-sizer
        @on-page-size-change="changePageSize"
        placement="top"
        :page-size-opts="pageArray">
      </Page>
    </div>
    <!--导出数据字段弹窗-->
    <exportFieldsModal
      ref="exportFields"
      :exportFieldsTitle="$t('key1005015')"
      paramKeyColums="ymsPackageInfoDataCenterExportColumns"
      :customFieldExportList="customFieldExportList"
      @exportFieldsDataBtn="exportFieldsDataBtn">
    </exportFieldsModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from "@/components/mixin/common_mixin";
import api from '@/api/';
import dropDownFilter from "@/components/common/dropDownFilter";
import exportFieldsModal from "@/components/common/exportFieldsModal";
import {_handleMultilingualFields, getAllUsersInfo, getQueryCarrierShippingName, getUserNameByUserId, pageJump, setConfigCharacters} from "@/utils/common";

export default {
  name: "deliveryDetails",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      pageParamsStatus: false,
      dropDownTextareaList: [
        {title: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000522')}`, value: 1, placeholder: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000324')}${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004996')}`, parameterKey: 'packageCodes'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002877'), value: 2, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004997'), parameterKey: 'distributorMerchantIds'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004435'), value: 3, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004998'), parameterKey: 'orderShippingIds'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003698'), value: 4, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004999'), parameterKey: 'trackingNumbers'}
      ],
      defaultTextareaValue: 1,
      dropDownInputList: [
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005000'), value: 1, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000101'), parameterKey: 'shipedBy'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005001'), value: 2, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000101'), parameterKey: 'pickingCreatedBy'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004734'), value: 3, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000101'), parameterKey: 'pickedBy'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004735'), value: 4, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000101'), parameterKey: 'sortedBy'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004691'), value: 5, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000101'), parameterKey: 'changedLabelBy'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005002'), value: 6, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000101'), parameterKey: 'boxedBy'}
      ],
      defaultSelectValue: 1,
      pageParams: {
        packageCodes: '', // 云卖订单号
        distributorMerchantIds: '', // 分销商商户号
        orderShippingIds: '', // 分销商订单号
        trackingNumbers: '', // 运单号
        shipedBy: null, // 出库人
        pickingCreatedBy: null, // 生成拣货单人
        pickedBy: null, // 完成拣货操作人
        sortedBy: null, // 完成分拣操作人
        changedLabelBy: null, // 完成包装操作人
        boxedBy: null, // 完成物流分拣操作人
        shipedTimeEnd: null, // 出库结束时间
        shipedTimeStart: null, // 出库开始时间
        ymsSkus: null, // 云卖SKU
        pageNum: 1,
        pageSize: 15
      },
      deliveryTime: [],
      total: 0,
      tableColumns: [
        {
          type: 'selection',
          width: 60,
          fixed: 'left',
          align: 'center'
        },
        {
          title: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000522')}`,
          key: 'packageCode',
          align: 'center',
          minWidth: 150,
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002877'),
          key: 'distributorMerchantId',
          align: 'center',
          minWidth: 150,
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004435'),
          key: 'orderShippingId',
          align: 'center',
          minWidth: 150,
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003840'),
          key: 'logistics',
          align: 'center',
          width: 220,
          render: (h, params) => {
            let carrierName = _handleMultilingualFields(params.row.carrierName) || '';
            let carrierShippingMethodName = _handleMultilingualFields(params.row.carrierShippingMethodName) || '';
            return h('div', carrierName + (carrierShippingMethodName ? ' > ' + carrierShippingMethodName : ''));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003698'),
          key: 'trackingNumber',
          align: 'center',
          minWidth: 150,
        },
        {
          title: `${setConfigCharacters(false)}SKU`,
          key: 'ymsSku',
          align: 'center',
          minWidth: 160,
          render(h, params) {
            let list = [];
            let ymsPackageGoods = params.row.ymsPackageGoods || [];
            if (ymsPackageGoods.length > 0) {
              ymsPackageGoods.map((item) => {
                list.push(h('p', {class: 'mt5 mb5'}, item.ymsSku));
              });
            }
            return h('div', list);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005003'),
          key: 'packageGoodsQuantity',
          align: 'center',
          minWidth: 150,
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005001'),
          key: 'pickingCreatedBy',
          align: 'center',
          minWidth: 150,
          render: (h, params) => {
            return h('div', getUserNameByUserId(params.row.pickingCreatedBy, v.userInfoList));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004734'),
          key: 'pickedBy',
          align: 'center',
          minWidth: 150,
          render: (h, params) => {
            return h('div', getUserNameByUserId(params.row.pickedBy, v.userInfoList));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004735'),
          key: 'sortedBy',
          align: 'center',
          minWidth: 150,
          render: (h, params) => {
            return h('div', getUserNameByUserId(params.row.sortedBy, v.userInfoList));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004691'),
          key: 'changedLabelBy',
          align: 'center',
          minWidth: 150,
          render: (h, params) => {
            return h('div', getUserNameByUserId(params.row.changedLabelBy, v.userInfoList));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005002'),
          key: 'boxedBy',
          align: 'center',
          minWidth: 150,
          render: (h, params) => {
            return h('div', getUserNameByUserId(params.row.boxedBy, v.userInfoList));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005000'),
          key: 'shipedBy',
          align: 'center',
          minWidth: 150,
          render: (h, params) => {
            return h('div', getUserNameByUserId(params.row.shipedBy, v.userInfoList));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005004'),
          key: 'allottedTime',
          align: 'center',
          minWidth: 180,
          render: (h, params) => {
            return h('span', v.$uDate.dealTime(params.row.allottedTime, 'fulltime'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005005'),
          key: 'pickingCreatedTime',
          align: 'center',
          minWidth: 180,
          render: (h, params) => {
            return h('span', v.$uDate.dealTime(params.row.pickingCreatedTime, 'fulltime'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005006'),
          key: 'pickedTime',
          align: 'center',
          minWidth: 180,
          render: (h, params) => {
            return h('span', v.$uDate.dealTime(params.row.pickedTime, 'fulltime'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005007'),
          key: 'sortedTime',
          align: 'center',
          minWidth: 180,
          render: (h, params) => {
            return h('span', v.$uDate.dealTime(params.row.sortedTime, 'fulltime'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005008'),
          key: 'changedLabelTime',
          align: 'center',
          minWidth: 180,
          render: (h, params) => {
            return h('span', v.$uDate.dealTime(params.row.changedLabelTime, 'fulltime'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005009'),
          key: 'boxedTime',
          align: 'center',
          minWidth: 180,
          render: (h, params) => {
            return h('span', v.$uDate.dealTime(params.row.boxedTime, 'fulltime'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005010'),
          key: 'shipedTime',
          align: 'center',
          minWidth: 180,
          render: (h, params) => {
            return h('span', v.$uDate.dealTime(params.row.shipedTime, 'fulltime'));
          }
        },
      ],
      tableData: [],
      dropDownList: [],
      selectTableData: [],
      exportType: '1',
      customFieldExportList: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000929'),
          titleKey: 'basicInfoColums',
          selectList: ['packageCodeCenter'], // 选中导出字段的key
          checkBoxList: [
            {paramKey: 'packageCodeCenter', paramValue: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000522')}`, disabled: true},
            {paramKey: 'distributorMerchantIdCenter', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002877')},
            {paramKey: 'orderShippingIdCenter', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004435')},
            {paramKey: 'shippingMethodIdCenter', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003840')},
            {paramKey: 'trackingNumberCenter', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005011')},
            {paramKey: 'ymsSkusCenter', paramValue: `${setConfigCharacters(false)}SKU`},
            {paramKey: 'packageGoodsQuantityCenter', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005012')},
          ]
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005013'),
          titleKey: 'operatorsColums',
          selectList: [], // 选中导出字段的key
          checkBoxList: [
            {paramKey: 'pickingCreatedByCenter', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005001')},
            {paramKey: 'pickedByCenter', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004734')},
            {paramKey: 'sortedByCenter', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004735')},
            {paramKey: 'changedLabelByCenter', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004691')},
            {paramKey: 'boxedByCenter', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005002')},
            {paramKey: 'shipedByCenter', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005000')}
          ]
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000291'),
          titleKey: 'operationTimeColums',
          selectList: [], // 选中导出字段的key
          checkBoxList: [
            {paramKey: 'allottedTimeCenter', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005004')},
            {paramKey: 'pickingCreatedTimeCenter', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005005')},
            {paramKey: 'pickedTimeCenter', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005006')},
            {paramKey: 'sortedTimeCenter', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005007')},
            {paramKey: 'changedLabelTimeCenter', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005008')},
            {paramKey: 'boxedTimeCenter', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005009')},
            {paramKey: 'shipedTimeCenter', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005010')}
          ]
        },
      ],
      userInfoList:{}
    };
  },
  created() {
    this.initFun();
  },
  methods: {
    // 初始化接口数据
    initFun() {
      let v = this;
      v.setDefaultTimerParams('three_months');
      (async () => {
        await getAllUsersInfo().then((data) => {
          v.userInfoList = data;
          v.dropDownList = [];
          if (data) {
            for (let key in data) {
              v.dropDownList.push({
                name: data[key].userName,
                value: data[key].userId
              });
            }
          }
        });
        await v.getList();
      })();
    },
    // 查询按钮
    search() {
      this.pageParams.pageNum = 1;
      this.pageParamsStatus = true;
    },
    // 重置按钮
    reset() {
      let v = this;
      v.deliveryTime = [];
      v.$refs['pageParams'].resetFields();
      v.resetDate();
      v.changeInput(1);
      v.changeTextareaInput(1);
      v.setDefaultTimerParams('three_months');
      v.getList();
    },
    // 参数处理
    handleParameter() {
      let v = this;
      let params = Object.assign({}, v.pageParams);
      let keyList = ['packageCodes', 'distributorMerchantIds', 'orderShippingIds', 'trackingNumbers', 'ymsSkus'];
      keyList.map((key) => {
        params[key] = v.pageParams[key] === '' ? [] : v.sepCommasFn(v.pageParams[key], ['\n']);
      });
      return params;
    },
    // 获取列表数据
    getList() {
      let v = this;
      v.tableData = [];
      v.total = 0;
      if (v.getPermission('ymsPackageInfoDataCenter_query')) {
        let shippingMethodIdsList = [];
        v.tableLoading = true;
        v.axios.post(api.post_ymsPackageInfoDataCenter_query, v.handleParameter()).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            let list = data.list || [];
            if (list.length > 0) {
              list.map((item) => {
                if (item.shippingMethodId) {
                  shippingMethodIdsList.push(item.shippingMethodId);
                }
              });
              // 获取物流商邮寄方式数据
              if (shippingMethodIdsList.length > 0) {
                getQueryCarrierShippingName(shippingMethodIdsList).then((newList) => {
                  list.map((item) => {
                    if (newList.length > 0) {
                      newList.map((ele) => {
                        if (ele.shippingMethodId === item.shippingMethodId) {
                          item.carrierShippingMethodName = ele.carrierShippingMethodName;
                          item.carrierName = ele.carrierName;
                        }
                      });
                    }
                  });
                  v.tableData = list;
                  v.$nextTick(() => {
                    v.tableLoading = false;
                  });
                });
              } else {
                v.tableData = list;
                v.$nextTick(() => {
                  v.tableLoading = false;
                });
              }
              v.total = data.total;
            } else {
              v.tableLoading = false;
            }
          }
        });
      } else {
        v.gotoError();
      }
    },
    // 获取费用产生时间
    getDateValue(value) {
      let v = this;
      if (value.length === 0) {
        v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000356'));
        v.resetDate();
      } else {
        if (!value[0]) {
          v.pageParams.shipedTimeStart = null;
          v.pageParams.shipedTimeEnd = null;
        } else {
          let timeList = v.defaultTimePeriod(value);
          v.deliveryTime = v.defaultTimePeriod(value, false);
          v.pageParams.shipedTimeStart = v.$uDate.getUniversalTime(new Date(timeList[0]).getTime(), 'fulltime');
          v.pageParams.shipedTimeEnd = v.$uDate.getUniversalTime(new Date(timeList[1]).getTime(), 'fulltime');
        }
      }
    },
    // 重置费用产生时间
    resetDate() {
      this.pageParams.shipedTimeStart = null;
      this.pageParams.shipedTimeEnd = null;
    },
    // 获取下拉选项筛选条件的值(类型是 textarea)
    updateTextareaValue(data) {
      this.pageParams[data.key] = data.value;
    },
    // 改变默认下拉选项的值(类型是 textarea)
    changeTextareaInput(value) {
      this.defaultTextareaValue = value;
      this.$refs.dropDownTextareaFilter.inputValue = '';
      this.dropDownTextareaList.map((item) => {
        if (Object.keys(this.pageParams).includes(item.parameterKey)) {
          this.pageParams[item.parameterKey] = '';
        }
      });
    },
    // 获取下拉选项筛选条件的值(类型是 text)
    updateInputValue(data) {
      this.pageParams[data.key] = data.value;
    },
    // 改变默认下拉选项的值(类型是 text)
    changeInput(value) {
      this.defaultSelectValue = value;
      this.$refs.dropDownFilter.inputValue = '';
      this.dropDownInputList.map((item) => {
        if (Object.keys(this.pageParams).includes(item.parameterKey)) {
          this.pageParams[item.parameterKey] = '';
        }
      });
    },
    // 勾选列表数据
    tableChange(data) {
      this.selectTableData = [];
      data.map((item) => {
        if (item.ymsPackageId) {
          this.selectTableData.push(item.ymsPackageId);
        }
      });
    },
    // 选择导出数据类型  1 按选中导出 2 按查询结果导出
    changeExportBtn(value) {
      this.exportType = value;
      if (value === '1') {
        if (this.selectTableData.length <= 0) {
          this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003077'));
          return false;
        }
      } else {
        if (this.tableData.length <= 0) {
          this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003078'));
          return false;
        }
      }
      this.$refs['exportFields'].getExportFieldsSetting();
    },
    // 导出数据
    exportFieldsDataBtn() {
      let v = this;
      let query = v.handleParameter();
      if (v.exportType === '1') {
        query.ymsPackageIds = v.selectTableData;
      } else {
        query.ymsPackageIds = [];
      }
      v.$refs['exportFields'].saveExportFieldsSetting().then((value) => {
        if (value) {
          v.axios.post(api.post_ymsPackageInfoDataCenter_export, query,
            {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(res => {
            if (res.data.code === 0) {
              v.$refs['exportFields'].exportFieldsModal = false;
              let taskNumber = res.data.datas;
              setTimeout(() => {
                pageJump('/yms.html#/exportTask?operateCode=' + taskNumber, '/yms-core-service', '_blank');
              }, 30);
            }
          });
        }
      });
    }
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    }
  },
  components: {
    dropDownFilter,
    exportFieldsModal
  }
};
</script>
